import moment from "moment";

// ✅ Fetch preferred formats from localStorage
const getDateTimeFormat = () => {
  // try {
  //   const stored = JSON.parse(localStorage.getItem("company_preference")) || {};
  //   return {
  //     dateFormate: stored.date_format || "DD MMM YYYY",
  //     timeFormate: stored.time_format || "hh:mm A",
  //   };
  // } catch {
  //   return { dateFormate: "DD MMM YYYY", timeFormate: "hh:mm A" };
  // }
  return { dateFormate: "DD MMM YYYY", timeFormate: "hh:mm A" };
};

/**
 * @param {string} dateString - Input date/time string
 * @param {"toUTC" | "toLocal" | "dateOnly" | null} conversionType - Type of conversion (optional)
 * @returns {string} Formatted date/time string
 */
export const getUserDateTime = (dateString, conversionType = null, format = null) => {
  if (!dateString || dateString.trim() === "") return "";

  //Detect if it's an ISO string (like 2025-08-14T13:37:00.000Z)
  const isISO = moment(dateString, moment.ISO_8601, true).isValid();

  // Supported input formats
  const inputFormats = [
    // Date + Time formats
    "DD MMM",
    "YYYY-MM-DD HH:mm",
    "YYYY-MM-DD HH:mm:ss",
    "DD/MM/YYYY HH:mm",
    "DD/MM/YYYY HH:mm:ss",
    "MM/DD/YYYY HH:mm",
    "MM/DD/YYYY HH:mm:ss",
    "DD-MM-YYYY HH:mm",
    "DD-MM-YYYY HH:mm:ss",
    "D MMM YYYY HH:mm",
    "D MMM YYYY HH:mm:ss",
    "DD MMMM YYYY HH:mm",
    "Do MMMM YYYY hh:mm A",
    "Do MMMM YYYY HH:mm",
    "MMM D, YYYY HH:mm",
    "MMM D, YYYY HH:mm:ss",
    "dddd, MMMM Do YYYY HH:mm",
    "dddd, MMMM Do YYYY hh:mm A",
    // Date-only formats
    "YYYY-MM-DD",
    "DD/MM/YYYY",
    "MM/DD/YYYY",
    "DD-MM-YYYY",
    "DD.MM.YYYY",
    "DD MMMM YY",
    "D MMM YYYY",
    "DD MMM YYYY",
    "Do MMM YYYY",
    "Do MMMM YYYY",
    "YYYY-MMM-DD",
    "MMMM Do YYYY",
    "dddd, MMMM Do YYYY",
    // Time-only formats
    "HH:mm",
    "HH:mm:ss",
    "hh:mm A",
    "hh:mm:ss A",
    "h:mm A",
    "h:mm:ss A",
  ];

  // Parse input
  // let date = moment(dateString.trim(), inputFormats, true);
  // if (!date.isValid()) {
  //   console.warn("Invalid date string:", dateString);
  //   return "-";
  // }

  // Parse date
  let date = isISO ? moment(dateString) : moment(dateString.trim(), inputFormats, true);
  if (!date.isValid()) {
    console.warn("Invalid date string:", dateString);
    return "-";
  }

  // Detect input type
  const isTimeOnlyInput =
    !dateString.includes("-") &&
    !dateString.includes("/") &&
    !dateString.includes(" ") &&
    (dateString.includes(":") || dateString.match(/^[0-9]{1,2}:[0-9]{2}(?:\s?[AP]M)?$/i));

  const isDateOnlyInput =
    dateString.match(/^\d{4}-\d{2}-\d{2}$/) ||
    dateString.match(/^\d{2}\/\d{2}\/\d{4}$/) ||
    dateString.match(/^\d{2}-\d{2}-\d{4}$/) ||
    dateString.match(/^\d{1,2}\s[A-Za-z]{3}\s\d{4}$/) ||
    dateString.match(/^\d{1,2}(?:st|nd|rd|th)?\s[A-Za-z]+\s\d{4}$/);

  // 🔄 Conditional conversion
  if (conversionType === "toUTC") {
    date = date.clone().utc();
  } else if (conversionType === "toLocal") {
    date = date.clone().local();
  }

  // Get user preferences
  const { dateFormate, timeFormate } = getDateTimeFormat();

  // 📅 Format output based on input type
  if (format === "dateOnly") {
    return date.format(dateFormate); //getUserDateTime("2025-10-23T20:01:00.000Z", "dateOnly")
  } else if (isTimeOnlyInput) {
    return date.format(timeFormate); //getUserDateTime("13:45", "toUTC")
  } else if (isDateOnlyInput) {
    return date.format(dateFormate); //getUserDateTime("2025-10-23", "toUTC")
  } else if (format === "dayAndMonth") {
    return date.format("DD MMM"); //getUserDateTime("23-jan", "toUTC")
  } else {
    return date.format(`${dateFormate} ${timeFormate}`); //getUserDateTime("2025-10-23 13:45", "toUTC")
  }
};
